<template>
  <v-container id="payment-transactions-details" fluid class="pa-0 ma-0">
    <template v-if="transactions.length === 0">
      <i-empty-results hideButton title="No transactions found" />
    </template>
    <template v-else>
      <v-data-table
        class="ml-8 y-2 my-md-6"
        :headers="headers"
        item-key="objectId"
        :items="transactions"
        :items-per-page="-1"
        mobile-breakpoint="960"
        hide-default-footer
      >
        <template #[`item.displayType`]="{ item }">
          <span>{{ $filters.text(item.displayType) }}</span>
        </template>

        <template #[`item.referenceNumber`]="{ item }">
          <router-link
            v-if="createLinkForTransaction(item)"
            class="i-a-link"
            :to="createLinkForTransaction(item)"
          >
            <span>{{ $filters.text(item.referenceNumber) }}</span>
          </router-link>
          <span v-else>{{ $filters.text(item.referenceNumber) }}</span>
        </template>

        <template #[`item.supplierOrderNumber`]="{ item }">
          <span>{{ $filters.text(item.supplierOrderNumber) }}</span>
        </template>

        <template #[`item.storeOrderReference`]="{ item }">
          <span>{{ $filters.text(item.storeOrderReference) }}</span>
        </template>

        <template #[`item.storeName`]="{ item }">
          <span>{{ $filters.text(item.storeName) }}</span>
        </template>

        <template #[`item.supplierPayoutTotalExTax`]="{ item }">
          <i-currency-display
            :dollarValue="item.supplierPayoutTotalExTax"
            :strong="false"
          ></i-currency-display>
        </template>

        <template #[`item.supplierPayoutTotalWet`]="{ item }">
          <i-currency-display
            :dollarValue="item.supplierPayoutTotalWet"
            :strong="false"
          ></i-currency-display>
        </template>

        <template #[`item.supplierPayoutTotalGst`]="{ item }">
          <i-currency-display
            :dollarValue="item.supplierPayoutTotalGst"
            :strong="false"
          ></i-currency-display>
        </template>

        <template #[`item.supplierPayoutTotalIncTax`]="{ item }">
          <i-currency-display
            :dollarValue="item.supplierPayoutTotalIncTax"
            :strong="false"
          ></i-currency-display>
        </template>

        <template #[`item.payoutDisplayDate`]="{ item }">
          <div class="payout-date-cell">
            <span>{{ $filters.formatDate(item.payoutDisplayDate) }}</span>
            <span v-if="item.payoutDisplayStatus" class="payout-date-status">
              {{ item.payoutDisplayStatus }}
            </span>
          </div>
        </template>
      </v-data-table>
    </template>
  </v-container>
</template>

<script>
import iEmptyResults from '@/components/EmptyResults'
import iCurrencyDisplay from '@/components/CurrencyDisplay.vue'

export default {
  components: {
    iCurrencyDisplay,
    iEmptyResults
  },

  props: {
    transactions: {
      default: () => [],
      type: Array,
      required: false
    },
    headers: {
      type: Array,
      required: true
    },
    createLinkForTransaction: {
      type: Function,
      required: true
    }
  },

  data: () => ({}),

  methods: {}
}
</script>

<style lang="scss" scoped>
#payment-transactions-details {
  .payout-date-cell {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .payout-date-status {
    color: #6b7280;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
    text-transform: uppercase;
  }
}
</style>
